<div class="p-8 bg-gray-100 min-h-screen flex justify-center items-start">
  <div class="bg-white p-6 w-full flex flex-col md:flex-row gap-8">
    
    <!-- Columna izquierda -->
    <div class="md:w-1/3 text-gray-700">
      <h3 class="text-xl font-semibold mb-4 px-4 lhe-1">
        {{ 'suppliers.intro_title' | translate }} <span class="font-bold">{{ 'suppliers.intro_title_bold' | translate }}</span>
      </h3>
      <ol class="space-y-4 mt-8">
        <li class="flex items-start">
          <div class="circle flex-shrink-0 w-8 h-8 bg-blue-500 flex items-center justify-center mr-4">1</div>
            <div>
              {{ 'suppliers.step_1_text' | translate }} <span class="font-bold">{{ 'suppliers.step_1_bold' | translate }}</span> {{ 'suppliers.step_1_continue' | translate }}
            </div>
        </li>
        <li class="flex items-start">
          <div class="circle flex-shrink-0 w-8 h-8 bg-blue-500 flex items-center justify-center mr-4">2</div>
            <div>
              {{ 'suppliers.step_2_text' | translate }} <span class="font-bold">{{ 'suppliers.step_2_bold' | translate }}</span> {{ 'suppliers.step_2_continue' | translate }}Once your VAT number has been validated, the <span class="font-bold">Supplier Portal</span> window will open so that you can complete the registration. In the portal, you will have to fill in the required fields and configure your payment preferences.
            </div>
        </li>
      </ol>
      <div class="mt-8">
        {{ 'suppliers.closing_text' | translate }}
      </div>
      <div class="mt-8 font-semibold">{{ 'suppliers.thank_you' | translate }}</div>
    </div>
    <!-- Línea vertical separadora -->
    <div class="w-px bg-gray-300 my-8"></div>
    <!-- Columna derecha -->
    <div class="md:w-1/2">
      <div class="pt-4">
        <h3 class="text-lg font-semibold mb-2">{{ 'suppliers.company_info_title' | translate }}</h3>
        <div class="mb-6 header"></div>
        <div class="text-sm text-gray-600 mb-4">
          {{ 'suppliers.important_notice' | translate }}
        </div>

        <!-- Alert de error de validación -->
        <alert *ngIf="showValidationError" type="error" [icon]="true" [closable]="true" (closed)="showValidationError = false" class="mb-4">
          {{ 'suppliers.validation_error' | translate }}
        </alert>

        <!-- Alert: errores de updateFiscalId (PROVIDER_ALREADY_EXISTS / PROVIDER_VALIDATION_ERROR) -->
        <alert *ngIf="updateErrorKey" [type]="updateErrorType" [icon]="true" [closable]="true" (closed)="updateErrorKey = null" class="mb-4">
          {{ updateErrorKey | translate }}
        </alert>

        <div class="flex items-center bg-white rounded-md py-8">
          <app-input
            class="mr-4"
            type="text"
            label="{{ 'suppliers.vat_id_label' | translate }}"
            placeholder="{{ 'suppliers.vat_id_placeholder' | translate }}"
            [value]="vatId"
            (change)="onVatIdChange($event)"
          ></app-input>
          <app-input
            [disabled]="true"
            class=""
            type="text"
            label="{{ 'suppliers.company_name_label' | translate }}"
            placeholder="{{ 'suppliers.company_name_placeholder' | translate }}"
            [value]="companyName"
          ></app-input>
        </div>
        <div class="flex items-center bg-white rounded-md">
          <app-button [skin]="'ctop'" [primary]="true" [isFullWidth]="true" [size]="'medium'" (onClick)="this.validate()">
            {{ 'suppliers.validate_vat_button' | translate }}
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>